import { handleServerExperimentViewed } from 'Shared/features';

handleServerExperimentViewed();
